let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Wy3V")).then(() => parcelRequire('ejhdy'));